import { FC } from 'react';
import { Icon } from 'semantic-ui-react';

import './VideoPlayIcon.scss';

export const VideoPlayIcon: FC = () => {
  return <Icon className="video-play-icon" name="play circle outline" size="huge" />;
};
